import { isNilOrEmpty } from '@yoop/util';
import type { DateOfBirth, UserProfile } from './models/user';

export const dateOfBirthFrom = (serverDate: string): DateOfBirth | undefined => {
  if (isNilOrEmpty(serverDate)) {
    return undefined;
  }
  const [year, month] = serverDate.split('-');
  return { year: parseInt(year), month: parseInt(month) };
};

//FIXME: creating a copy of [UserProfileResponse] model because the lib is not currently buildable.
interface ServerResponseUserModel {
  globalUserId: string;
  dateOfBirth: string;
  emailAddress: string;
  firstName: string;
  lastName: string;
  profilePictureUrl: string;
  userAuthenticationState: any; //UserAuthenticationState
  profilePictureVerificationStatus: boolean;
  countryCode: string;
  postalCode: string;
}

export const mapUserProfileFrom = (response: ServerResponseUserModel): UserProfile => {
  return {
    globalUserId: response.globalUserId,
    dateOfBirth: dateOfBirthFrom(response.dateOfBirth),
    emailAddress: response.emailAddress,
    firstName: response.firstName,
    lastName: response.lastName,
    pictureUrl: response.profilePictureUrl,
    isEmailVerified: response.userAuthenticationState === 'EMAIL_VERIFIED',
    isPictureVerified: response.profilePictureVerificationStatus,
    countryCode: response.countryCode,
    postalCode: response.postalCode,
  };
};
